import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Container, Typography, TextField, Button, Alert,
} from '@mui/material';
import axios from '../utils/axios';
import useTelegram from '../hooks/useTelegram';

PhoneRegistration.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default function PhoneRegistration({ onSuccess }) {
  const { telegramUser } = useTelegram();
  const [phone, setPhone] = useState('+998');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const cleaned = phone.replace(/\s/g, '');
    if (cleaned.length < 12) {
      setError('Telefon raqam noto\'g\'ri');
      return;
    }

    setLoading(true);
    try {
      await axios.post('/students/auth/register-phone', {
        phone: cleaned,
        firstName: telegramUser?.first_name,
        lastName: telegramUser?.last_name,
        username: telegramUser?.username,
      });
      onSuccess();
    } catch (err) {
      setError(err?.message || 'Xatolik yuz berdi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', bgcolor: 'background.default' }}>
      <Container maxWidth="xs">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            EssePro
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Davom etish uchun telefon raqamingizni kiriting
          </Typography>
        </Box>

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Telefon raqam"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+998901234567"
            sx={{ mb: 2 }}
          />

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={loading}
          >
            {loading ? 'Yuborilmoqda...' : 'Davom etish'}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
